<template>
  <profile-layout>
    <template slot="sidebar">
    </template>
    <template slot="left">
      <div >
        <div >
          <div class="">
            <header-card  ></header-card>
          </div>

          <div class="proposal-section">
            <proposal-detail></proposal-detail>
          </div>

        </div>
      </div>
    </template>
    <template slot="right">
        <voting></voting>
    </template>
  </profile-layout>
</template>

<script>
import ProfileLayout from '@/templates/profile-layout'
import HeaderCard from '../components/dao-community/proposal/header-card.vue'
import ProposalDetail from '../components/dao-community/proposal/proposal-detail.vue'
import Voting from '../components/dao-community/proposal/voting.vue'

export default {
  name: 'ProposalPage',
  components: {
    ProposalDetail,
    HeaderCard,
    ProfileLayout,
    Voting
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  },
  async mounted () {
  },
  beforeDestroy () {
  }
}
</script>

<style lang="scss" scoped>
div.section:first-child {
  padding: 0;
}

div.section {
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-top: 2.5rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/proposal.vue